// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5s-2";
export var blackBorderOnHover = "_5s-7";
export var cell = "_5s-6";
export var cellContainer = "_5s-3";
export var checked = "_5s-8";
export var disabled = "_5s-5";
export var featuredIconCellContainer = "_5s-9";
export var featuredIconTextContainer = "_5s-b";
export var featuredIconWrapper = "_5s-a";
export var noBorder = "_5s-c";
export var orangeSelectedRow = "_es-3";
export var overflowableText = "_5s-0";
export var overflowableTextContainer = "_5s-1";
export var row = "_5q-0";
export var rowCheckboxCell = "_5s-4";
export var selectableTable = "_es-2";